import React, { useState, useContext, useRef, useEffect } from "react";
import DataTable from "react-data-table-component";
import { IoCloudDownloadOutline } from "react-icons/io5";
import jsPDF from 'jspdf'; 
import 'jspdf-autotable';
import exportFromJSON from "export-from-json";
import dayjs from "dayjs"; 

//internal import
import PageHeader from "../../components/common/PageHeader";
import ModalLoading from "../../components/Loading/ModalLoading";
import useAsync from "../../hooks/useAsync";
import DropDownService from "../../services/DropDownService";
import ReportService from "../../services/ReportService";
import { allContext } from "../../context/AllContext"; 
import TableLoading from "../../components/Loading/TableLoading";

function ScheduleReport() {

    const printRef = useRef();
    const [employeeId, setEmployeeId] = useState("");
    const [clientID, setclientID] = useState("");
    const [project, setProject] = useState(""); 
    const [status, setStatus] = useState("");
    const [fromDate, setfromDate] = useState(dayjs().format("YYYY-MM-DD"));   
    const [toDate, settoDate] = useState(dayjs().format("YYYY-MM-DD"));  
    const { reportSearch, setReportSearch } = useContext(allContext);

    const { data, loading, tableLoading } = useAsync(() => ReportService.getAllScheduleReport({ employeeId:employeeId, clientId:clientID, fromDate, toDate, project, status, page:"", limit:"" }));
    const { data: employeeDropdown } = useAsync(() => DropDownService.employeeDropDown());
    const { data: clientDropdown } = useAsync(() => DropDownService.clientDropDown()); 
    const { data: projectDropdown } = useAsync(() => DropDownService.projectDropDown());

    let columnT = ""; 
  
    columnT = [
        {
            name: "S.NO.",
            selector: (_, index) => index + 1,
            sortable: true
        },
        {
            name: "MEETING NO.",
            selector: (row) => row?.scheduleNo,
            sortable: true
        },
        {
            name: "CLIENT",
            selector: (row) => row?.clientName || "-",
            sortable: true, 
            // minWidth: "250px"
        },
        {
            name: "EMP. NAME",
            selector: (row) => row?.employeeName,
            // minWidth: "250px",
            sortable: true
        },
        {
            name: "PROJECT",
            selector: (row) => row?.projectName || "-",
            sortable: true
        }, 
        {
            name: "DATE",
            selector: (row) => row?.scheduleDate,
            sortable: true
        },
        {
            name: "FROM TIME",
            selector: (row) => row?.fromTime,
            sortable: true
        },
        {
            name: "TO TIME",
            selector: (row) => row?.toTime,
            sortable: true
        },
        {
            name: "STATUS",
            sortable: true,
            cell: row => <span className={`badge ${row.status === "Completed" || row.status === "Active" ? 'bg-success' : "bg-warning"}`}>{row?.status}</span>
        }
    ];

    const handleDownloadReport = async (downloadType) => { 
        try {
            const res = await ReportService.getAllScheduleReport({ employeeId:employeeId, clientId:clientID, fromDate, toDate, project, status, page: "", limit: "" });
            if (downloadType === "pdf" && res?.success) {
                const exportData = res?.data?.map((val, index) => {
                    return [
                        index+1,
                        val?.scheduleNo,
                        val?.clientName,
                        val?.employeeName,
                        val?.projectName,
                        val?.scheduleDate,
                        val?.fromTime,
                        val?.toTime,
                        val?.status 
                    ]
                });
                const head = ["S.NO.", "MEETING NO.", "CLIENT NAME", "EMP. NAME", "PROJECT TYPE", "MEETING DATE", "FROM TIME", "TO TIME", "STATUS"];
                const unit = "pt";
                const size = "A4"; // Use A1, A2, A3 or A4
                const orientation = "landscape"; // portrait or landscape  
                const doc = new jsPDF(orientation, unit, size);
                doc.setFontSize(15);
                const headers = [head];
                let content = {
                    startY: 50,
                    head: headers,
                    body: exportData
                };

                const header = "Meeting Report";
                const footer = dayjs().format("DD-MM-YYYY hh:mm A");
                const pageSize = doc.internal.pageSize;
                const pageWidth = pageSize.width || pageSize.getWidth();
                const pageHeight = pageSize.height || pageSize.getHeight();

                doc.text(header, 40, 15);
                doc.text("CRM with Sunpro", 500, 15, { baseline: 'top' });
                doc.autoTable(content);
                doc.setFontSize(8);
                doc.text(footer, pageWidth / 1.2, pageHeight - 50, { baseline: 'bottom' });

                doc.save("meeting-report" + Date.now() + ".pdf");
            }
            else if (downloadType === "csv" || downloadType === "xls") {
                const exportData = res?.data?.map((val, index) => {
                    return {
                        "S.NO.": index + 1,
                        "MEETING NO.": val?.scheduleNo,
                        "CLIENT NAME": val?.clientName, 
                        "EMP. NAME": val?.employeeName,
                        "PROJECT TYPE": val?.projectName,
                        "MEETING DATE": val?.scheduleDate,
                        "FROM TIME": val?.fromTime,
                        "TO TIME": val?.toTime, 
                        "STATUS": val.status
                    }
                });
                exportFromJSON({
                    data: exportData,
                    fileName: "meeting-report" + Date.now(),
                    exportType: downloadType,
                });
            }
        } catch (error) {
            console.error("error", error)
        }
    }

    const handleFilter = (e, val) => {
        if (val === "emp") {
            setEmployeeId(e.target.value); 
        }
        else if (val === "client") {
            setclientID(e.target.value); 
        }
        else if (val === "project") {
            setProject(e.target.value); 
        }
        else if (val === "status") {
            setStatus(e.target.value); 
        }
        else if (val === "fromDate") {
            setfromDate(e.target.value); 
        } 
        else if (val === "toDate") {
            settoDate(e.target.value);  
        } 
    }

    const handleClearFilter = () => {
        setEmployeeId("");
        setclientID("");
        setProject("");
        setStatus("");
        setfromDate(dayjs().format("YYYY-MM-DD"));  
        settoDate(dayjs().format("YYYY-MM-DD")); 
        setReportSearch(!reportSearch);
    } 
 
    useEffect(() => {
        handleResetButton();
    }, []);
 
    const handleResetButton = async () => {
        setfromDate(dayjs().format("YYYY-MM-DD"));  
        settoDate(dayjs().format("YYYY-MM-DD"));
        setEmployeeId(""); 
        setclientID("");  
        setProject("");  
        setStatus("");    
        setReportSearch(!reportSearch);   
    } 
 
    return (
        <div className="container-xxl">
            {loading ? <ModalLoading loading={loading} /> :
                <>
                    <PageHeader headerTitle="Meeting Report" renderRight={() => {
                        return <div className="col-auto d-flex w-sm-100">
                        </div>
                    }} />
                    <div className="row">
                        <div className="col-lg-12 d-flex flex-wrap gap-3">
                            <div className=" col-lg-3"> 
                                <label className="form-label">From Date</label>
                                <input name="leaveFrom" type="date" className="form-control" id="datepickerdedass"value={fromDate} onChange={(e) => setfromDate(e.target.value)}/> 
                            </div>
                            <div className=" col-lg-3"> 
                                <label className="form-label">To Date</label>
                                <input name="leaveTo" type="date" className="form-control" id="datepickerdedass" value={toDate} onChange={(e) => settoDate(e.target.value)}/> 
                            </div>
                            <div className=" col-lg-3">
                                <label className="form-label">Select Employee</label>
                                <select className="form-select" value={employeeId}
                                    onChange={(e) => setEmployeeId(e.target.value)}
                                > 
                                    <option value="">--- All Employee ---</option>
                                    {employeeDropdown?.data?.map((val, idx) => (
                                        <option key={idx} value={val?.value}>{val?.label}</option>
                                    ))
                                    }
                                </select>
                            </div>
                            <div className=" col-lg-3">
                                <label className="form-label">Select Client</label>
                                <select className="form-select" value={clientID}
                                    onChange={(e) => setclientID(e.target.value)}
                                >
                                    <option value="">--- All Client ---</option>
                                    {clientDropdown?.data?.map((val, idx) => (
                                        <option key={idx} value={val?.value}>{val?.label}</option>
                                    ))
                                    }
                                </select>
                            </div> 
                            <div className=" col-lg-3">
                                <label className="form-label">Select Project</label>
                                <select className="form-select" value={project}
                                    onChange={(e) => setProject(e.target.value)}
                                >
                                    <option value="">--- All Project ---</option>
                                    {projectDropdown?.data?.map((val, idx) => (
                                        <option key={idx} value={val?.value}>{val?.label}</option>
                                    ))
                                    } 
                                </select>
                            </div>
                            <div className=" col-lg-3"> 
                                <label className="form-label">Select Status</label>
                                <select className="form-select"value={status}
                                    onChange={(e) => setStatus(e.target.value)}
                                >
                                    <option value="">--- All Status ---</option>
                                    <option value="Need to Approach">Need to Approach</option> 
                                    <option value="Interested">Interested</option> 
                                    <option value="Request">Request</option> 
                                    <option value="Confirm">Confirm</option> 
                                    <option value="Pending">Pending</option> 
                                    <option value="Reject">Reject</option> 
                                </select>
                            </div>
                            <div className=" col-lg-2"> 
                                <div className="mt-4 py-1 me-1">
                                    <button className="btn btn-dark  px-3 me-1" type="submit" onClick={() => handleResetButton()}><span className="text-white dark:text-gray-200">Reset</span></button>
                                    <button className="btn btn-dark  px-3 " type="submit" onClick={() => setReportSearch(!reportSearch)}><span className="text-white dark:text-gray-200">Search</span></button>
                                </div>
                            </div>     
                        </div>                        
                    </div> 
                    <div className="row ">
                        <div className="col-lg-12 p-4 pt-6 mt-1 d-flex justify-content-end ">
                            <button className={`btn btn-dark btn-set-task w-sm-100 m-2 ${data?.data.length === 0 && "opacity-50"}`} onClick={() => data?.data.length !== 0 && handleDownloadReport("csv")}><span className=" me-2 fs-6"><IoCloudDownloadOutline /></span> CSV </button>
                            <button className={`btn btn-dark btn-set-task w-sm-100 m-2 ${data?.data.length === 0 && "opacity-50"}`} onClick={() => data?.data.length !== 0 && handleDownloadReport("xls")}><span className=" me-2 fs-6"><IoCloudDownloadOutline /></span>EXCEL</button>
                            <button className={`btn btn-dark btn-set-task w-sm-100 m-2 ${data?.data.length === 0 && "opacity-50"}`} onClick={() => data?.data.length !== 0 && handleDownloadReport("pdf")}><span className=" me-2 fs-6"><IoCloudDownloadOutline /></span>PDF</button>
                            {/* <button onClick={() => handlePrint} className="btn btn-dark btn-set-task w-sm-100 m-2">
                                <span className=" me-2 fs-6"><FiPrinter /></span>
                                Print
                            </button>  */}

                        </div>
                    </div>
                    <div className="row clearfix g-3">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body" ref={printRef}>
                                    <DataTable
                                        title="Meeting"
                                        columns={columnT}
                                        data={data?.data}
                                        defaultSortField="title"
                                        pagination 
                                        selectableRows={false}
                                        className="table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                                        highlightOnHover={true}
                                        progressPending={tableLoading}
                                        progressComponent={<TableLoading row={10} col={7} width={160} height={20} />}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
        </div>
    )
}


export default ScheduleReport;